import React, { useState /* useContext */ } from "react";
import { FormLayout, Autocomplete, InlineStack, Tag } from "@shopify/polaris";
import PropTypes from "prop-types";

import { baseHelper } from "lib/helpers";
// import { PrivateContext } from "lib/context/privateContext";
import constant from "lib/constant/constant";

const Tags = (props) => {
  // const { cms } = useContext(PrivateContext);
  const { values = {}, selected = [], onChange, label, placeholder, id } = props;

  const tagOptions = baseHelper.sort((values && values.tags && values.tags.length && values.tags) || []);
  const sortedOptions = tagOptions;
  const options = sortedOptions.map((item) => ({ label: item, value: item }));
  const [state, setState] = useState({
    options: [],
    selected,
    inputText: "",
  });

  const handleChange = (val) => {
    const selectedTags = [];
    val.forEach((value) => {
      const selectedVal = options.find((item) => item.value === value);
      if (selectedVal) {
        selectedTags.push(selectedVal.value);
      }
    });
    setState({ ...state, selected: selectedTags });
    onChange(constant.ORGANISATION_TAGS, selectedTags);
  };

  const filterAndUpdateOptions = (inputString) => {
    if (!inputString) {
      setState({
        ...state,
        inputText: inputString,
      });
      return;
    }
    const filterRegex = new RegExp(inputString, "i");
    const resultOptions = options.filter((option) => option.label.match(filterRegex));
    setState({
      ...state,
      inputText: inputString,
      options: resultOptions,
    });
  };

  const updateText = (newValue) => {
    filterAndUpdateOptions(newValue);
  };

  const removeTag = (tag) => {
    const { selected: selectedTag } = state;
    const valueIndex = selectedTag.findIndex((item) => item === tag);
    if (valueIndex !== -1) {
      selectedTag.splice(valueIndex, 1);
    }
    setState({ ...state, selectedTag });
    onChange(constant.ORGANISATION_TAGS, selectedTag);
  };

  const renderTags = () => {
    const { selected: renderSelectedTag } = state;
    const selectedTags = options.filter((item) => renderSelectedTag.includes(item.value));
    let tagFields = baseHelper.sort(selectedTags, "label").map((item) => {
      return (
        <Tag key={item.label} onRemove={() => removeTag(item.value)}>
          {item.label}
        </Tag>
      );
    });
    tagFields = tagFields.filter((item) => item);
    return <InlineStack>{tagFields}</InlineStack>;
  };

  const textField = (
    <Autocomplete.TextField
      label={label}
      id={id}
      value={state.inputText}
      onChange={(value) => updateText(value)}
      placeholder={placeholder}
    />
  );

  return (
    <FormLayout>
      <Autocomplete
        allowMultiple
        options={state.options}
        textField={textField}
        selected={state.selected}
        onSelect={handleChange}
        listTitle="Available Options"
      />
      {renderTags()}
    </FormLayout>
  );
};

Tags.propTypes = {
  values: PropTypes.objectOf(PropTypes.shape).isRequired,
  selected: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

Tags.defaultProps = {
  selected: [],
};

export default Tags;
